import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard que verifica si el usuario está autenticado (tiene un JWT válido)
 * Si no está autenticado, redirige a /login
 * 
 * Uso: Para rutas que requieren usuario autenticado (ej: profile, cambiar contraseña)
 * 
 * {
 *   path: 'profile',
 *   component: ProfileComponent,
 *   canActivate: [authGuard]
 * }
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verificar si hay usuario autenticado
  if (authService.isAuthenticated()) {
    // Usuario autenticado, permitir acceso
    return true;
  }

  // No autenticado: redirigir a login
  console.warn('🚫 Acceso a ruta protegida sin autenticación. Redirigiendo a /login');
  router.navigate(['/login'], { 
    queryParams: { returnUrl: state.url } 
  });
  
  return false;
};
